import { IClient } from "@pages/auth/login";
import { SortData, defaultSortData } from "@utils/constants";
import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IGlobal_InformationStore {
  currentScreen: any;
  nextFunc:any;
  setNextFunc: (x: any) => void;
  setCurrentScreen: (x: any) => void;
  memberDetailGlobalReminder: any;
  setMemberDetailGlobalReminder: (x: any) => void;
  memberDetailGlobalAlert: any;
  setMemberDetailGlobalAlert: (x: any) => void;
  selectedHospitalListFacility: any;
  setSelectedHospitalListFacility: (x: any) => void;
  autoScroll : boolean;
  setAutoSroll : (x: any) => void;

  //patientList used in notes and reminders
  globalPatientList: any;
  setGlobalPatientList : (x: any) => void;
  globalPatientListLoader: boolean;
  setGlobalPatientListLoader: (x: any) => void;
  client: IClient | undefined;
  setClient: (x: any) => void;
  _isNextScrollNeeded : boolean;
  _setisNextScrollNeeded : (x: any) => void;
  memberDetailListRegistryDropDown : any;
  setMemberDetailListRegistryDropDown : (x: any) => void;
  secrets: any;
  setsecrets: (x: any) => void;
  sortData : SortData;
  setSortData :  (x:any) => void;
  memberDetailClassificationValues: any;
  setMemberDetailClassificationValues: (x:any) => void;
  globalPatientSearchText: any;
  setGlobalPatientSearchText: (x:any) => void;
  clearStore: () => void;
}

let store: StateCreator<IGlobal_InformationStore, [], [], IGlobal_InformationStore> | StoreApi<IGlobal_InformationStore> = (set: SetState<IGlobal_InformationStore>) => ({
  currentScreen: "",
  setCurrentScreen: (x) => {
    set((state) => ({ currentScreen: x }));
  },
  nextFunc: () => {},
  setNextFunc: (x) => {
    set((state) => ({ nextFunc: x }));
  },

  memberDetailGlobalReminder: [],
  setMemberDetailGlobalReminder: (x) => {
    set((state) => ({ memberDetailGlobalReminder: x }));
  },
  /* in memberDetailGlobalAlert objects 
  alerts is the array of alerts data 
  totalNotifications is the count of total number of alerts
  latest_datetime is the date time to fetch the alerts that are added after the previous notification api fetch
  datetime is to get all the alerts excluding the alerts that are added after the previous notification api fetch
  */
  memberDetailGlobalAlert: {alerts : [] , totalAlerts : 0 },
  setMemberDetailGlobalAlert: (x) => {
    set((state) => ({ memberDetailGlobalAlert: x }));
  },
  autoScroll:false,
  setAutoSroll: (x) => {
    set((state) => ({ autoScroll: x }));
  },
  selectedHospitalListFacility: "",
  setSelectedHospitalListFacility: (x) => {
    set((state) => ({ selectedHospitalListFacility: x }));
  },
  globalPatientList: [],
  setGlobalPatientList: (x) => {
    set((state) => ({ globalPatientList: x }));
  },

  globalPatientListLoader: false,
  setGlobalPatientListLoader: (x) => {
    set((state) => ({ globalPatientListLoader: x }));
  },
  _isNextScrollNeeded :  false,
  _setisNextScrollNeeded : (x) => {
    set((state) => ({ _isNextScrollNeeded: x }));
  },
  secrets: {},
  setsecrets: (x: any) => {
    set((state) => ({ secrets: x}));
  },
  client: undefined,
  setClient: (x) => {
    set((state) => ({ client: x }));
  },
  memberDetailListRegistryDropDown : [],
  setMemberDetailListRegistryDropDown: (x) => {
    set((state) => ({ memberDetailListRegistryDropDown: x }));
  },
  sortData: {},
  setSortData : (x) => {
    set((state) => ({ sortData: x }));
  },
  memberDetailClassificationValues : null,
  setMemberDetailClassificationValues : (x) => {
    set((state) => ({ memberDetailClassificationValues: x }));
  },
  globalPatientSearchText : undefined,
  setGlobalPatientSearchText : (x) => {
    set((state) => ({ globalPatientSearchText: x }));
  },
  clearStore: () => {
    set(() => ({ currentScreen: "" }));
    set(() => ({ nextFunc: ()=> {} }));
    set(() => ({ client : undefined }));
    set(() => ({ _isNextScrollNeeded : false }));
    set(() => ({ memberDetailGlobalReminder : [] }));
    set(() => ({ memberDetailGlobalAlert : {alerts : [] , totalAlerts : 0} }));
    set(() => ({ selectedHospitalListFacility : "" }));
    set(() => ({ autoScroll : false }));
    set(() => ({ globalPatientList : [] }));
    set(() => ({ globalPatientListLoader : false }));
    set(() => ({ sortData : defaultSortData }));
    set(() => ({ memberDetailClassificationValues : null }));
    set(() => ({ globalPatientSearchText : undefined }));
  },
});

export const useGlobalInformationStore = create(store);
